import { Component, OnInit, inject } from '@angular/core';

import { FcmTokenService } from './_services/fcm-token/fcm-token.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { NgxPullToRefreshModule } from 'ngx-pull-to-refresh';
import { RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, NgxPullToRefreshModule],
})
export class AppComponent implements OnInit {
    private splashScreenService = inject(FuseSplashScreenService);
    private fcmTokenService = inject(FcmTokenService);

    isAndroidApp = false;

    ngOnInit(): void {
        console.log(
            'Fcm Token Recu dans la webApp ==> ',
            this.fcmTokenService.fcmToken()
        );
        this.splashScreenService.show();
        //  DéfinituserAgent
        const userAgent = navigator.userAgent.toLowerCase();

        //  Détection Android WebView
        this.isAndroidApp =
            /android/.test(userAgent) &&
            (userAgent.includes('wv') || userAgent.includes('version/'));

        if (this.isAndroidApp) {
            document.body.classList.add('android-app');
        }
    }

    myRefreshEvent(event: Subject<any>, message: string) {
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    }
}
